import lodash from 'lodash';
import MatchStatistic from '../interfaces/matchStatistic';

export default function (matchStatistic: MatchStatistic): MatchStatistic {
  const response: any = lodash.clone(matchStatistic);
  delete response.status;

  return response;
}
